import { render, staticRenderFns } from "./NsToast.vue?vue&type=template&id=0588b350&scoped=true&"
import script from "./NsToast.vue?vue&type=script&lang=js&"
export * from "./NsToast.vue?vue&type=script&lang=js&"
import style0 from "./NsToast.vue?vue&type=style&index=0&id=0588b350&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0588b350",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBottomSheet,VSheet})


/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0588b350')) {
      api.createRecord('0588b350', component.options)
    } else {
      api.reload('0588b350', component.options)
    }
    module.hot.accept("./NsToast.vue?vue&type=template&id=0588b350&scoped=true&", function () {
      api.rerender('0588b350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsToast.vue"
export default component.exports